import { useEffect, useState } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { useAuth } from './contexts/AuthContext';
import { createRouter } from './router';
import { queryClient } from './lib/queryClient';
import LandingPage from './components/LandingPage';
import { Footer } from './components/VersionDisplay';
import './App.css';
import { MantineProvider } from '@mantine/core';

const router = createRouter();

function App() {
  const { isAuthenticated, isLoading, refreshUser, user } = useAuth();
  const [isOAuthCallback, setIsOAuthCallback] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authParam = urlParams.get('auth');

    if (authParam === 'success') {
      setIsOAuthCallback(true);
      window.history.replaceState({}, document.title, window.location.pathname);
      setTimeout(() => {
        refreshUser().finally(() => {
          setIsOAuthCallback(false);
        });
      }, 300);
    } else if (authParam === 'employee_not_found') {
      window.history.replaceState({}, document.title, window.location.pathname);
      window.location.href = '/contact-support';
    }
  }, [refreshUser]);

  if (isLoading || isOAuthCallback) {
    return (
      <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  const isContactSupport = window.location.pathname === '/contact-support';

  if (!isAuthenticated && !isContactSupport) {
    return (
      <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
        <LandingPage />
        <Footer />
      </div>
    );
  }

  return (
    <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">

      <RouterProvider
        router={router}
        context={{
          auth: {
            user: user || null,
            isAuthenticated,
          },
          queryClient,
        }}
      />
      <Footer />
    </div>
  );
}

export default App;
